import React, { useState } from 'react';
import Logo from "../../assets/Logo.svg";
import LogoAlt from "../../assets/logoAlt.svg";
// import { IoIosArrowDown } from "react-icons/io";
// import { IoIosArrowUp } from "react-icons/io";
// import { useLocation } from 'react-router-dom';
import { CiMenuBurger } from "react-icons/ci";
import './Navbar.css'

import EarlyAccessBtn from '../baseComponents/EarlyAccessBtn';
const Navbar = ({ background, alternative, bottomBorder }) => {
    // const [isOpen, setIsOpen] = useState(false);
    // const location = useLocation();
    // const toggleDropdown = () => {
    //     setIsOpen(!isOpen);
    // };
    const bgStyle = {
        background: background,
        borderBottom: bottomBorder
    };
    // const isProductsBlue = location.pathname.includes("/consumer") || location.pathname.includes("/contributor");

    const currentPath = window.location.pathname;
    const isPricingActive =
        (currentPath === '/' || currentPath === '') &&
        window.location.hash === '#pricing';


    const isActive = (path) => {
        if (path === '/blog') {
            return currentPath === '/blog' || currentPath.startsWith('/blog/')
                ? 'active'
                : '';
        }
        return currentPath === path ? "active" : "";
    };

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const toggleSidebar = () => {
        setSidebarVisible(!sidebarVisible); // Toggle the sidebar visibility
    };

    const handlePricingClick = (event) => {
        const isHome =
            window.location.pathname === '/' || window.location.pathname === '';

        if (!isHome) {
            setSidebarVisible(false);
            return;
        }

        event.preventDefault();
        setSidebarVisible(false);

        const pricingSection = document.getElementById('pricing');
        if (!pricingSection) return;

        pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

        if (window.location.hash !== '#pricing') {
            window.history.pushState(null, '', '/#pricing');
        }
    };

    return (
        <div className="nav-container" style={bgStyle}>
            <div className="page-container nav-inner">

            <nav className={`${alternative === "active" ? "nav-links alt" : "nav-links"}`}>
                {alternative === "active" ?
                    <a href="/#">
                        <img src={LogoAlt} alt="logo"
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxWidth: '121px',

                            }}
                        />
                    </a>
                    :
                    <a href="/#">
                        <img src={Logo} alt="logo"
                            style={{
                                width: '100%',
                                height: 'auto',
                                maxWidth: '121px',

                            }}
                        />
                    </a>
                }


                <ul>
                    <li><a href="/about" className={isActive("/about")}>About</a></li>
                    <li><a href="/services" className={isActive("/services")}>Services</a></li>
                    <li>
                        <a
                            href="/#pricing"
                            className={isPricingActive ? 'active' : ''}
                            onClick={handlePricingClick}
                        >
                            Pricing
                        </a>
                    </li>
                    <li><a href="/blog" className={isActive("/blog")}>Blog</a></li>
                    <li><a href="/contact" className={isActive("/contact")}>Contact</a></li>
                </ul>


            </nav>
            <div className={`${alternative === "active" ? "nav-btns alt" : "nav-btns"}`}>
                {/* <button>Get Early Access</button> */}
                <span><a target='_blank'rel='noreferrer' href="https://app.sonaroid.io/login">Login</a></span>
                <EarlyAccessBtn
                    // height="44px"
                    padding=".5em 1em"
                />
            </div>
            <CiMenuBurger className={`${alternative === "active" ? "menu-button" : "menu-button alt"}`} onClick={() => toggleSidebar()} />

            <ul className={`sidebar ${sidebarVisible ? 'visible' : ''}`}>

                <li><a href="/about" className={isActive("/about")}>About</a></li>
                <li><a href="/services" className={isActive("/services")}>Services</a></li>
                <li>
                    <a
                        href="/#pricing"
                        className={isPricingActive ? 'active' : ''}
                        onClick={handlePricingClick}
                    >
                        Pricing
                    </a>
                </li>
                <li><a href="/blog" className={isActive("/blog")}>Blog</a></li>
                <li><a href="/contact" className={isActive("/contact")}>Contact</a></li>
            </ul>

            </div>

        </div>
    )
}

export default Navbar
